/* esm.sh - react-remove-scroll@2.7.2/dist/es2015/SideEffect */
export * from "/*react-remove-scroll@2.7.2/esnext/dist/es2015/SideEffect.mjs";
